import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function CollapsibleBoxComponent({
  title,
  children,
  isMobile,
  defaultExpanded,
}) {
  return (
    <Box
      sx={{
        maxWidth: '100%',
        margin: 'auto',
        mt: isMobile ? 1.5 : 2,
        border: '1px solid #D9E0E8',
        borderRadius: isMobile ? '18px' : '20px',
        backgroundColor: '#FFFFFF',
        overflow: 'hidden',
        boxShadow: '0 2px 10px rgba(22, 47, 59, 0.04)',
      }}
    >
      <Accordion
        defaultExpanded={defaultExpanded === undefined ? true : defaultExpanded}
        sx={{
          border: 'none',
          borderRadius: '0',
          backgroundColor: 'transparent',
          boxShadow: 'none',
          width: '100%',
          '&::before': {
            display: 'none',
          },
          '& .MuiAccordionSummary-root': {
            backgroundColor: 'transparent',
            px: isMobile ? 2.5 : 3,
            py: isMobile ? 1.25 : 2,
          },
          '& .MuiAccordionDetails-root': {
            backgroundColor: 'transparent',
            px: isMobile ? 2.5 : 3,
            pb: isMobile ? 2 : 3,
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: '#000' }} />}
          aria-controls="panel-content"
          id="panel-header"
          sx={{
            backgroundColor: '#FFFFFF',
            '& .MuiTypography-root': {
              fontFamily: 'Inter',
              fontWeight: 600,
              fontSize: isMobile ? '1rem' : '1.25rem',
              lineHeight: '120%',
              letterSpacing: '0em',
            },
          }}
        >
          <Typography>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ backgroundColor: '#FFFFFF' }}>
          {children}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
